import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractSliceComponent } from './contract-slice.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [ContractSliceComponent],
  entryComponents: [ContractSliceComponent],
})
export class ContractSliceModule { }
